export default __webpack_public_path__ + "static/watch2earn-2dc11110554274bce77f985fedea0084.svg";